<div class="actions">
	<app-button
		appearance="secondary"
		size="s"
		[isDisabled]="openedDropdown() === dropdownVariantEnum.OPTION_INFO_ORDER"
		[tuiDropdownMinHeight]="600"
		[tuiDropdownMaxHeight]="600"
		[tuiDropdown]="infoOrderDropdown"
		[tuiDropdownManual]="openedDropdown() === dropdownVariantEnum.OPTION_INFO_ORDER"
		(clicked)="toggleDropdown(dropdownVariantEnum.OPTION_INFO_ORDER)"
	>
		{{ 'optionsOrders.info' | translate }}
	</app-button>

	@if (checkCanEdit()) {
		<app-button
			appearance="secondary"
			size="s"
			[isDisabled]="openedDropdown() === dropdownVariantEnum.OPTION_CHANGE_ORDER"
			[tuiDropdownMinHeight]="600"
			[tuiDropdownMaxHeight]="600"
			[tuiDropdown]="changeOrderDropdown"
			[tuiDropdownManual]="openedDropdown() === dropdownVariantEnum.OPTION_CHANGE_ORDER"
			(clicked)="toggleDropdown(dropdownVariantEnum.OPTION_CHANGE_ORDER)"
		>
			{{ 'optionsOrders.edit' | translate }}
		</app-button>
	}

	@if (checkCanCancel()) {
		<app-button
			appearance="secondary"
			size="s"
			[isDisabled]="openedDropdown() === dropdownVariantEnum.OPTION_CANCEL_ORDER"
			[tuiDropdownMinHeight]="600"
			[tuiDropdownMaxHeight]="600"
			[tuiDropdown]="cancelOrderDropdown"
			[tuiDropdownManual]="openedDropdown() === dropdownVariantEnum.OPTION_CANCEL_ORDER"
			(clicked)="toggleDropdown(dropdownVariantEnum.OPTION_CANCEL_ORDER)"
		>
			{{ 'optionsOrders.cancel' | translate }}
		</app-button>
	}
</div>

<ng-template #changeOrderDropdown>
	<div
		appClickOutside
		(clickOutside)="onClickOutside()"
	>
		<app-change-options-order
			[order]="option()"
			(closeDropdown)="toggleDropdown(null)"
		/>
	</div>
</ng-template>

<ng-template #cancelOrderDropdown>
	<div
		appClickOutside
		(clickOutside)="onClickOutside()"
	>
		<app-cancel-options-order
			[order]="option()"
			(closeDropdown)="toggleDropdown(null)"
		/>
	</div>
</ng-template>

<ng-template #infoOrderDropdown>
	<div
		appClickOutside
		(clickOutside)="onClickOutside()"
	>
		<app-info-options-order
			[order]="option()"
			(closeDropdown)="toggleDropdown(null)"
		/>
	</div>
</ng-template>
